<template>
    <div id="epos-vue-app">
        <SyncProgress />

        <EposMenuBar />

        <OverlayStack />

        <EposFullPageContainer />

        <EmbeddedComponents />
    </div>
</template>

<script>
import EmbeddedComponents from '@/epos/vue/components/EmbeddedComponents';
import EposFullPageContainer from '@/epos/vue/components/EposFullPageContainer';
import EposMenuBar from '@/epos/vue/components/EposMenuBar';
import OverlayStack from '@/vue/components/Modals/OverlayStack';
import SyncProgress from '@/vue/components/Syncing/SyncProgress';
import { setBottomBarVisibleBodyClass } from '@/lib/Dom/domFunctions';

export default {
    name: 'EposAppRoot',

    components: {
        EmbeddedComponents,
        EposFullPageContainer,
        EposMenuBar,
        OverlayStack,
        SyncProgress,
    },

    watch: {
        '$store.state.bottomBarVisible': {
            handler(newValue) {
                setBottomBarVisibleBodyClass(newValue);
            },
        },
    },
};
</script>
